let projects = document.getElementsByClassName('project-entry')

function handleEnterEvents(project) {
    if (debug) {
        console.log("project hover id: " + project.dataset.id + " type: " + project.dataset.type)
    }

    if (project.dataset.type === "odd") {
        let counterpart = document.getElementById("pos-" + (parseInt(project.dataset.id) +1));
        counterpart.classList.add("counterpart")
        project.classList.add("enter")

    } else if (project.dataset.type === "even") {
        let counterpart = document.getElementById("pos-" + (parseInt(project.dataset.id) -1));
        counterpart.classList.add("counterpart")
        project.classList.add("enter")
    }

}
function handleLeaveEvents(project) {
    if (debug) {
        console.log("project leave id: " + project.dataset.id + " type: " + project.dataset.type)
    }

    if (project.dataset.type === "odd") {
        let counterpart = document.getElementById("pos-" + (parseInt(project.dataset.id) +1));
        console.log("pos-" + (parseInt(project.dataset.id) +1))
        counterpart.classList.remove("counterpart")
        project.classList.remove("enter")

    } else if (project.dataset.type === "even") {
        let counterpart = document.getElementById("pos-" + (parseInt(project.dataset.id) -1));
        console.log("pos-" + (parseInt(project.dataset.id) -1))
        counterpart.classList.remove("counterpart")
        project.classList.remove("enter")
    }
}


/**
 * initial button event listener adding
 */
function setEventListeners() {
    if (debug) {
        console.log("initial setEventListeners")
    }

    Object.entries(projects).forEach(function (project) {
        project[1].addEventListener("mouseenter", () => handleEnterEvents(project[1]), false, true)
        project[1].addEventListener("mouseleave", () => handleLeaveEvents(project[1]), false, true)
        /**
         * touch events mobile
         */
        project[1].addEventListener("touchenter", () => handleEnterEvents(project[1]), false, true)
        project[1].addEventListener("touchleave", () => handleLeaveEvents(project[1]), false, true)
    })
}

document.addEventListener('DOMContentLoaded', function () {
    /**
     * run some functions for a first init
     */
    setEventListeners()
});
